import { PlaybookTabLayout } from '../PlaybookTabLayout';
import { ActivityOverTime } from './ActivityOverTime';
import { PlaysSessionsBreakdownCard } from './PlaysSessionsBreakdownCard';

export const ActivityTab = () => {
  return (
    <PlaybookTabLayout>
      <div className="flex flex-col gap-6">
        <div className="h-[300px]">
          <ActivityOverTime />
        </div>
        <div className="pb-10">
          <PlaysSessionsBreakdownCard />
        </div>
      </div>
    </PlaybookTabLayout>
  );
};
